import React, { useEffect, useState, useRef } from 'react';

import { Grid } from '@material-ui/core';
import { History } from '@material-ui/icons';

import { useMesaEntrada } from '../../../hooks/useCases/useMesaEntrada';
import { useStylesMUI } from '../../../styles/home/style';
import { TemplateABM } from '../../atomic/templates/TemplateABM';
import { GSelect } from '../../atomic/atoms/Select';
import { IconButtonGeneric } from '../../atomic/atoms/Buttons';
import { GenericModal } from '../../atomic/organisms/GenericModal';
import TableGeneric from '../../compartidos/abms/TableGeneric';
import moment from 'moment';

const initModal = {
  open: false,
  title: '',
};

export const TramitesDestinosABM = () => {
  const classes = useStylesMUI();
  const componentRef = useRef();
  const mesa = useMesaEntrada();

  const [tracking, setTracking] = useState(initModal);

  useEffect(() => {
    mesa.get.tramites();
    mesa.get.destinos();
  }, []);
  console.log(mesa.data.tramites);
  ;
  return (
    <Grid
      container
      justify="center"
      style={{ marginTop: '2em' }}
      className={classes.root}
    >
      <Grid item xs={12} md={10}>
        <TemplateABM
          tableProps={{ sizeTableCells: ['10%', '40%', '50%'] }}
          without={{
            title: true,
            update: true,
            insert: true,
            delete: true,
          }}
          titles={{
            abm: 'Tramites - Destinos / Mesa de Entrada',
          }}
          dataTable={{
            list: mesa.data.tramites,
            columns: [
              {
                label: 'Historial',
                customBody: (item) => (
                  <IconButtonGeneric
                    ariaLabel="historial"
                    Icon={History}
                    color="primary"
                    onClick={() => {
                      mesa.get.byId.trackingTramitesDestinos(item.idTramite);
                      setTracking({
                        open: true,
                        title: `Historial - ${item.descripcion}`,
                      });
                    }}
                  />
                ),
              },
              {
                label: 'Tramites',
                id: 'descripcion',
              },
              {
                label: 'Destinos',
                customBody: (item) => (
                  <div style={{ padding: '0.5em' }}>
                    <GSelect
                      variant="standard"
                      name="idDestino"
                      value={!!item?.idDestino ? item.idDestino : 0}
                      onChange={(e) => {
                        mesa.put.tramite({
                          id: item.idTramite,
                          idDestino: e.target.value,
                        });
                      }}
                      menuItems={[
                        { label: 'No posee', value: 0 },
                        ...mesa.data.destinos.map((d) => ({
                          label: d.descripcion,
                          value: d.id,
                        })),
                      ]}
                    />
                  </div>
                ),
              },
            ],
          }}
        />

        {tracking.open && (
          <GenericModal
            open={tracking.open}
            closeModal={() => {
              setTracking(initModal);
              mesa.clean.trackingTramitesDestinos();
            }}
            title={tracking.title}
            gridStyle={{ textAlign: 'center', padding: '1em' }}
            maxWidth="sm"
          >
            <TableGeneric
              ref={componentRef}
              data={mesa.data.trackingTramitesDestinos}
              align="center"
              colTitleStyle={{ fontSize: '1.2em' }}
              columns={[
                {
                  id: 'estadoAnterior',
                  label: 'Destino Anterior',
                },
                {
                  id: 'estadoActual',
                  label: 'Destino Actual',
                },
                {
                  id: 'usuario',
                  label: 'Usuario',
                },
                {
                  label: 'Fecha',
                  customBody: (item) =>
                    moment(item.fecha).format('DD/MM/YYYY - hh:mm'),
                },
              ]}
            />
          </GenericModal>
        )}
      </Grid>
    </Grid>
  );
};
